/**
 * 組合員の声管理画面outputクラス
 *
 * @export KYMW0A00OutputModel
 * @class KYMW0A00OutputModel
 */
export class KYMW0A00OutputModel {
  /**
   * 受付番号
   */
  public receiptNum = String('');

  /**
 * 問合せ内容
 */
  public inquiryContents = String('');
}
